module.exports = __webpack_public_path__ + "img/scratch-holder.02d1ef5e.png";